module.exports = __webpack_public_path__ + "static/media/agent_certificate.3a772583.svg";